import SinglePlanter from "./SinglePlanter";
import {ProductData} from "../providers/product/product-types";

interface PlanterSelectorProps {
    plant: ProductData;
    plants: ProductData[];
    setPlant: (plant: ProductData) => void;
}

const PlanterSelector = ({plants, plant, setPlant}: PlanterSelectorProps) => {
    return (
        <div className="relative bg-gray-50">
            <div className="border-b border-gray-200">
                <div className="flex h-32 items-center justify-center gap-16 text-center">
                    {plants.map((p, index) => (
                        <SinglePlanter isSelected={plant.id === p.id} plant={p} onClick={setPlant} key={index} />
                    ))}
                </div>
            </div>
        </div>
    )
};

export default PlanterSelector;